import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-caret-flat",
  "use": "tamr-icon-caret-flat-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-caret-flat\"><path d=\"M25,18H7a2.2,2.2,0,0,1-2-2,2.2,2.2,0,0,1,2-2H25a2.2,2.2,0,0,1,2,2A2.2,2.2,0,0,1,25,18Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol